import Vue from 'vue'
import VueRouter from 'vue-router'
import agreezc from '../views/agreezc.vue'
import shareImg from '../views/shareImg.vue'
import index from '../views/index.vue'
import no from '../views/no.vue'
import sign from '../views/sign.vue'
import ssss from '../views/ssss.vue'
import sssss from '../views/sssss.vue'
import success from '../views/success.vue'
import success4 from '../views/success4.vue'
import success7 from '../views/success7.vue'
import wxband from '../views/wxband.vue'
import wxlogin from '../views/wxlogin.vue'
import price from '../views/price.vue'
import { system } from './routerUtil'
import registered from '../views/registered.vue'
import aboutUs from '../views/aboutUs.vue'
import aboutVAT from '../views/aboutVAT.vue'
import aboutPacking from '../views/aboutPacking.vue'
import aboutAgent from '../views/aboutAgent.vue'
import aboutBattery from '../views/aboutBattery.vue'
import aboutWEEE from '../views/aboutWEEE.vue'
import VAT from '../views/Vat/VAT.vue'
import vatDetail from '../views/Vat/vatDetail.vue'
import about from '../views/aboutUs/index'
import customerService from '../views/customerService.vue'
import mailIndex from '../views/mail/mail.vue'
import statement from '../views/statement.vue'
import signSuccess from '../views/signSuccess.vue'
import land4 from '@/views/land4'
import land8 from '@/views/land8'
import { isMobile } from '@/util/util'

import store from '../store'
import { Toast } from 'vant'
Vue.use(VueRouter)
Vue.use(Toast)

const routes = [
  {
    path: '/agreeys',
    name: 'agreeys',
    component: agreezc
  },
  // 邮件
  {
    path: '/mailIndex',
    name: 'mailIndex',
    component: mailIndex
  },
  {
    path: '/wxband',
    name: 'wxband',
    component: wxband
  },
  {
    path: '/wxlogin',
    name: 'wxlogin',
    component: wxlogin
  },
  {
    path: '/aboutUs',
    name: 'aboutUs',
    component: aboutUs
  },
  {
    path: '/aboutVAT',
    name: 'aboutVAT',
    component: aboutVAT
  },
  {
    path: '/aboutPacking',
    name: 'aboutPacking',
    component: aboutPacking
  },
  {
    path: '/aboutAgent',
    name: 'aboutAgent',
    component: aboutAgent
  },
  {
    path: '/aboutBattery',
    name: 'aboutBattery',
    component: aboutBattery
  },
  {
    path: '/aboutWEEE',
    name: 'aboutWEEE',
    component: aboutWEEE
  },
  {
    path: '/VAT',
    name: 'VAT',
    component: VAT
  },
  // 首页
  {
    path: '/index',
    name: 'index',
    alias: '/registered',
    component: registered
  },
  {
    path: '/',
    name: 'index'
  },
  // 价格
  {
    path: '/price',
    name: 'price',
    component: price
  },
  {
    path: '/agreezc',
    name: 'agreezc',
    component: agreezc
  },
  {
    path: '/land1',
    name: 'land1',
    component: land4
  },
  {
    path: '/land4',
    name: 'land4',
    component: land4
  },
  {
    path: '/land8',
    name: 'land8',
    component: land8
  },
  {
    path: '/land21',
    name: 'land21',
    component: land4
  },
  {
    path: '/land22',
    name: 'land22',
    component: land4
  },
  {
    path: '/shareImg',
    name: 'shareImg',
    component: shareImg
  },
  {
    path: '/no',
    name: 'no',
    component: no
  },
  {
    path: '/sign',
    name: 'sign',
    component: sign
  },
  {
    path: '/ssss',
    name: 'ssss',
    component: ssss
  },
  {
    path: '/sssss',
    name: 'sssss',
    component: sssss
  },
  {
    path: '/success',
    name: 'success',
    component: success
  },
  {
    path: '/success4',
    name: 'success4',
    component: success4
  },
  {
    path: '/success7',
    name: 'success7',
    component: success7
  },
  {
    path: '/vatDetail',
    name: 'vatDetail',
    component: vatDetail
  },
  {
    path: '/customerService',
    name: 'customerService',
    component: customerService
  },
  // 关于我们--------微信公众号使用
  {
    path: '/about',
    name: 'about',
    component: about
  },
  {
    path: '/shareActive',
    name: 'shareActive',
    component: () => import('@/views/shareActive.vue')
  },
  {
    path: '/shareActives',
    name: 'shareActives',
    component: () => import('@/views/shareActive.vue')
  },
  {
    path: '/shareActiveSuccess',
    name: 'shareActiveSuccess',
    component: () => import('@/views/shareActiveSuccess.vue')
  },
  {
    path: '/finallyActive',
    name: 'finallyActive',
    component: () => import('@/views/finallyActive.vue')
  },
  {
    path: '/receive',
    name: 'receive',
    component: () => import('@/views/receive.vue')
  },
  {
    path: '/statement',
    name: 'statement',
    component: statement
  },
  {
    path: '/signSuccess',
    name: 'signSuccess',
    component: signSuccess
  },
  ...system,
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/Layout/404')
  },
  {
    path: '*',
    redirect: '/404'
  }
]
// 免登录白名单
const whiteList = [
  'login',
  'agreeys',
  'wxband',
  'wxlogin',
  'agreezc',
  'land',
  'land1',
  'land4',
  'land8',
  'land21',
  'land22',
  'sign',
  'ssss',
  'sssss',
  'about',
  'shareActiveSuccess',
  'finallyActive',
  'success',
  'success4',
  'success7',
  'sssss',
  'index',
  'registered',
  'aboutVAT',
  'aboutPacking',
  'aboutBattery',
  'aboutAgent',
  'aboutWEEE',
  'aboutUs',
  'VAT',
  'vatDetail',
  'price',
  'loginBottom',
  'loginLoading',
  'loginList',
  'login',
  'loginTest',
  'forget',
  'shareActive',
  'shareActives',
  'receive',
  'customerService',
  'mailIndex',
  'statement',
  'signSuccess',
  'errorUrl'
]
const router = new VueRouter({
  mode: 'history',
  base: '',
  routes
})
var ua = navigator.userAgent.toLowerCase() // 判断是否在微信浏览器
var isWeixin = ua.indexOf('micromessenger') != -1 // 判断是否在微信浏览器
var phone = navigator.userAgent // 设备机型的相关信息
phone = phone.substring(phone.indexOf('(') + 1, phone.indexOf(';')) // 处理信息，输出phone
router.beforeEach((to, from, next) => {
  if (!isMobile() && !['sign', 'statement', 'signSuccess'].includes(to.name)) {
    // pc端，跳转
    if (['land1', 'land4', 'land21'].includes(to.name)) {
      // 渠道页，跳商户端注册页
      window.open(`${process.env.VUE_APP_MDT_WWW_URL}/registered${window.location.search}`, '_self')
      return next(false)
    } else if (['land8'].includes(to.name)) {
      // 路径不变
      window.open(`${process.env.VUE_APP_MDT_USER_URL}${window.location.pathname}${window.location.search}`, '_self')
      return next(false)
    } else if (['land22'].includes(to.name)) {
      window.open(`${process.env.VUE_APP_MDT_USER_URL}/user/register${window.location.search}`, '_self')
      return next(false)
    }

    // 别的跳官网
    window.open(`${process.env.VUE_APP_MDT_WWW_URL}${window.location.search}`, '_self')
    return next(false)
  }
  if (to.path === '/') {
    const queryStr = new URLSearchParams(to.query).toString()
    location.href = `/index${queryStr ? '?' + queryStr : ''}`
    return
  }

  console.log(
    to.fullPath,
    '-----------------区分h5和公众号页面路径-----------------'
  )
  let a = document.createElement('script')
  if (to.fullPath.indexOf('/system') > -1) {
    console.log('公众号页面')
    a.src = 'https://hm.baidu.com/hm.js?22597ec126cc83c5710227a0d3740714'
  } else if (!['statement', 'sign', 'signSuccess'].includes(to.name)) {
    console.log('h5页面')
    a.src = 'https://hm.baidu.com/hm.js?22597ec126cc83c5710227a0d3740714'
  }
  let b = document.getElementsByTagName('script')[0]
  b.parentNode.insertBefore(a, b)
  if (
    to.name == 'cartList' ||
    to.name == 'buyList' ||
    to.name == 'mine' ||
    to.name == 'searchList' ||
    to.name == 'DeclarationRecord' ||
    to.name == 'taxNumber' ||
    to.name == 'letterList' ||
    to.name == 'WorkOrderList' ||
    to.name == 'CurrentDeclaration' ||
    to.name == 'vatList' ||
    to.name == 'orderList'
  ) {
    store.state.leftIcon = true
  } else {
    store.state.leftIcon = false
  }
  let channelListUrl = [
    'index',
    'aboutVAT',
    'aboutWEEE',
    'aboutPacking',
    'aboutBattery',
    'aboutAgent',
    'VAT',
    'aboutUs',
    'registered'
  ]
  if (channelListUrl.includes(to.name)) {
    store.state.needChannelUrl = true
  } else {
    store.state.needChannelUrl = false
  }
  console.log(store.state.leftIcon, '======================')
  if (
    to.query &&
    (to.query.state == 'shareActive' || to.query.state == 'shareActives') &&
      to.query.code &&
    to.name != 'shareActive' && to.name != 'shareActives'
  ) {
    let o = { name: to.query.state }
    o.query = { ...to.query }
    delete o.query.state
    if (to.query.state == 'shareActive1') {
      o.query.otherState = 'shareActive1'
    }
    next(o)
    return
  }
  // Vue.ls.set('ACCESS_TOKEN','58a7253756c84f49a1dff608e3796336')
  if (Vue.ls.get('ACCESS_TOKEN')) {
    //   /* has token */
    if (to.name === 'system' && to.query.code) {
      let openId = Vue.ls.get('WX_OPENID')
      let code = to.query.code || from.query.code
      if (code && openId) {
        store.dispatch('switchWxCheck', { code, openId }).then(res => {
          if (res.code == 0) {
            if (
              to.query.state &&
              to.query.state != 'STATE' &&
              to.query.state != 'active'
            ) {
              next({ name: to.query.state, replace: true })
            } else if (to.query.state && to.query.state == 'active') {
              next({ name: 'mine', query: { active: 'active' } })
            } else {
              if (
                isWeixin &&
                phone.indexOf('Windows') == -1 &&
                  phone.indexOf('Macintosh') == -1
              ) {
                // let pathStr = '/system/user/loginBottom';
                Vue.ls.remove('ACCESS_TOKEN')
                Vue.ls.remove('WX_OPENID')
                store.dispatch('loginMp', { code: code }).then(res => {
                  if (res.code == 0) {
                    if (res.data && res.data.serialNo) {
                      Vue.ls.set('WX_OPENID', res.data.serialNo)
                    } else {
                      Vue.ls.set('WX_OPENID', res.data)
                    }
                    Vue.ls.set('WX_STATE', to.query.state)
                    Vue.ls.set('ACCESS_TOKEN', res.token)
                    next({ name: 'loginLoading', query: res.data })
                  } else if (res.code == 5) {
                    if (res.data && res.data[0].serialNo) {
                      Vue.ls.set('WX_OPENID', res.data[0].serialNo)
                    } else {
                      Vue.ls.set('WX_OPENID', res.data)
                    }
                    Vue.ls.set('WX_STATE', to.query.state)
                    next({
                      name: 'loginList',
                      query: { list: res.data, type: 2 }
                    })
                  } else if (res.code == 2) {
                    if (res.data && res.data.serialNo) {
                      Vue.ls.set('WX_OPENID', res.data.serialNo)
                    } else {
                      Vue.ls.set('WX_OPENID', res.data)
                    }
                    Vue.ls.set('WX_STATE', to.query.state)
                    next({ name: 'login' })
                  } else {
                    Vue.ls.remove('ACCESS_TOKEN')
                    Vue.ls.remove('WX_OPENID')
                    let isPrdUrl = window.location.href
                    let str = ''
                    let str1 = ''
                    let str3 = ''
                    if (to.query.state && to.query.state != 'STATE') {
                      str3 = to.query.state
                    } else {
                      str3 = 'STATE'
                    }
                    if (isPrdUrl.indexOf('m.evatmaster.com') != -1) {
                      str = 'wxc0eebdec65b19c45'
                      str1 = 'm.evatmaster.com%2fsystem'
                    } else if (
                      isPrdUrl.indexOf('m1.mp.evatmaster.com') != -1 ||
                      isPrdUrl.indexOf('m1.ost.com') != -1
                    ) {
                      str = 'wx9c6b7411242fab1a'
                      str1 = 'm1.mp.evatmaster.com%2fsystem'
                    } else if (
                      isPrdUrl.indexOf('m.mp.evatmaster.com') != -1 ||
                      isPrdUrl.indexOf('m.ost.com') != -1
                    ) {
                      str = 'wxd171949afbc94bbb'
                      str1 = 'm.mp.evatmaster.com%2fsystem'
                    } else {
                      str = 'wxf00dd2ff877812bf'
                      str1 = 'wjw.mp.evatmaster.com%2fsystem'
                    }
                    if (
                      isWeixin &&
                      phone.indexOf('Windows') == -1 &&
                        phone.indexOf('Macintosh') == -1
                    ) {
                      let str2 = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${str}&redirect_uri=http%3a%2f%2f${str1}%2f&response_type=code&scope=snsapi_userinfo&state=${str3}#wechat_redirect`
                      window.location.href = str2
                    } else if (
                      isWeixin &&
                      (phone.indexOf('Windows') != -1 ||
                        phone.indexOf('Macintosh') != -1)
                    ) {
                      window.location.href =
                        'https://user.evatmaster.com/user/login'
                    } else {
                      next({
                        name: 'loginTest',
                        query: { redirect: to.fullPath }
                      })
                    }
                  }
                })
              } else if (
                isWeixin &&
                (phone.indexOf('Windows') != -1 ||
                  phone.indexOf('Macintosh') != -1)
              ) {
                window.location.href = 'https://user.evatmaster.com/user/login'
              } else {
                Vue.ls.remove('ACCESS_TOKEN')
                Vue.ls.remove('WX_OPENID')
                next({ name: 'loginTest', query: { redirect: to.fullPath } })
              }
            }
          } else {
            // Toast({
            //     message: '重新获取授权信息',
            //     duration: 3000
            // })
            store.dispatch('Logout').then(() => {
              Vue.ls.remove('ACCESS_TOKEN')
              Vue.ls.remove('WX_OPENID')
              let isPrdUrl = window.location.href
              let str = ''
              let str1 = ''
              let str3 = ''
              if (to.query.state && to.query.state != 'STATE') {
                str3 = to.query.state
              } else {
                str3 = 'STATE'
              }
              if (isPrdUrl.indexOf('m.evatmaster.com') != -1) {
                str = 'wxc0eebdec65b19c45'
                str1 = 'm.evatmaster.com%2fsystem'
              } else if (
                isPrdUrl.indexOf('m1.mp.evatmaster.com') != -1 ||
                isPrdUrl.indexOf('m1.ost.com') != -1
              ) {
                str = 'wx9c6b7411242fab1a'
                str1 = 'm1.mp.evatmaster.com%2fsystem'
              } else if (
                isPrdUrl.indexOf('m.mp.evatmaster.com') != -1 ||
                isPrdUrl.indexOf('m.ost.com') != -1
              ) {
                str = 'wxd171949afbc94bbb'
                str1 = 'm.mp.evatmaster.com%2fsystem'
              } else {
                str = 'wxf00dd2ff877812bf'
                str1 = 'wjw.mp.evatmaster.com%2fsystem'
              }
              if (
                isWeixin &&
                phone.indexOf('Windows') == -1 &&
                  phone.indexOf('Macintosh') == -1
              ) {
                let str2 = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${str}&redirect_uri=http%3a%2f%2f${str1}%2f&response_type=code&scope=snsapi_userinfo&state=${str3}#wechat_redirect`
                window.location.href = str2
              } else if (
                isWeixin &&
                (phone.indexOf('Windows') != -1 ||
                  phone.indexOf('Macintosh') != -1)
              ) {
                window.location.href = 'https://user.evatmaster.com/user/login'
              } else {
                next({ name: 'loginTest', query: { redirect: to.fullPath } })
              }
            })
          }
        })
      } else {
        if (
          isWeixin &&
          phone.indexOf('Windows') == -1 && phone.indexOf('Macintosh') == -1
        ) {
          // let pathStr = '/system/user/loginBottom';
          Vue.ls.remove('ACCESS_TOKEN')
          Vue.ls.remove('WX_OPENID')
          store
            .dispatch('loginMp', { code: to.query.code || from.query.code })
            .then(res => {
              if (res.code == 0) {
                if (res.data && res.data.serialNo) {
                  Vue.ls.set('WX_OPENID', res.data.serialNo)
                } else {
                  Vue.ls.set('WX_OPENID', res.data)
                }
                Vue.ls.set('WX_STATE', to.query.state)
                Vue.ls.set('ACCESS_TOKEN', res.token)
                next({ name: 'loginLoading', query: res.data })
              } else if (res.code == 5) {
                if (res.data && res.data[0].serialNo) {
                  Vue.ls.set('WX_OPENID', res.data[0].serialNo)
                } else {
                  Vue.ls.set('WX_OPENID', res.data)
                }
                Vue.ls.set('WX_STATE', to.query.state)
                next({ name: 'loginList', query: { list: res.data, type: 2 } })
              } else if (res.code == 2) {
                if (res.data && res.data.serialNo) {
                  Vue.ls.set('WX_OPENID', res.data.serialNo)
                } else {
                  Vue.ls.set('WX_OPENID', res.data)
                }
                Vue.ls.set('WX_STATE', to.query.state)
                next({ name: 'login' })
              } else {
                Vue.ls.remove('ACCESS_TOKEN')
                Vue.ls.remove('WX_OPENID')
                let isPrdUrl = window.location.href
                let str = ''
                let str1 = ''
                let str3 = ''
                if (to.query.state && to.query.state != 'STATE') {
                  str3 = to.query.state
                } else {
                  str3 = 'STATE'
                }
                if (isPrdUrl.indexOf('m.evatmaster.com') != -1) {
                  str = 'wxc0eebdec65b19c45'
                  str1 = 'm.evatmaster.com%2fsystem'
                } else if (
                  isPrdUrl.indexOf('m1.mp.evatmaster.com') != -1 ||
                  isPrdUrl.indexOf('m1.ost.com') != -1
                ) {
                  str = 'wx9c6b7411242fab1a'
                  str1 = 'm1.mp.evatmaster.com%2fsystem'
                } else if (
                  isPrdUrl.indexOf('m.mp.evatmaster.com') != -1 ||
                  isPrdUrl.indexOf('m.ost.com') != -1
                ) {
                  str = 'wxd171949afbc94bbb'
                  str1 = 'm.mp.evatmaster.com%2fsystem'
                } else {
                  str = 'wxf00dd2ff877812bf'
                  str1 = 'wjw.mp.evatmaster.com%2fsystem'
                }
                if (
                  isWeixin &&
                  phone.indexOf('Windows') == -1 &&
                    phone.indexOf('Macintosh') == -1
                ) {
                  let str2 = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${str}&redirect_uri=http%3a%2f%2f${str1}%2f&response_type=code&scope=snsapi_userinfo&state=${str3}#wechat_redirect`
                  window.location.href = str2
                } else if (
                  isWeixin &&
                  (phone.indexOf('Windows') != -1 ||
                    phone.indexOf('Macintosh') != -1)
                ) {
                  window.location.href =
                    'https://user.evatmaster.com/user/login'
                } else {
                  next({ name: 'loginTest', query: { redirect: to.fullPath } })
                }
              }
            })
          // next({ path:pathStr ,query:to.query})
        } else if (
          isWeixin &&
          (phone.indexOf('Windows') != -1 || phone.indexOf('Macintosh') != -1)
        ) {
          window.location.href = 'https://user.evatmaster.com/user/login'
        } else {
          Vue.ls.remove('ACCESS_TOKEN')
          Vue.ls.remove('WX_OPENID')
          next({ name: 'loginTest', query: { redirect: to.fullPath } })
        }
      }
    } else if (whiteList.includes(to.name)) {
      next()
    } else {
      if (!store.state.info) {
        store
          .dispatch('GetInfo')
          .then(() => {
            if (
              isWeixin &&
              (phone.indexOf('Windows') != -1 ||
                phone.indexOf('Macintosh') != -1)
            ) {
              window.location.href = 'https://user.evatmaster.com/user/login'
            } else {
              if (
                (from.path === '/system' && to.path === '/404') ||
                to.path === '/system'
              ) {
                next({ name: 'mine' })
              } else {
                next({ ...to, replace: true })
              }
            }
          })
          .catch(() => {
            Toast({
              message: '请求用户信息失败，请重试',
              duration: 3000
            })
            store.dispatch('Logout').then(() => {
              Vue.ls.remove('ACCESS_TOKEN')
              if (Vue.ls.get('WX_OPENID')) {
                Vue.ls.remove('WX_OPENID')
                let isPrdUrl = window.location.href
                let str = ''
                let str1 = ''
                let str3 = ''
                if (to.query.state && to.query.state != 'STATE') {
                  str3 = to.query.state
                } else {
                  str3 = 'STATE'
                }
                if (isPrdUrl.indexOf('m.evatmaster.com') != -1) {
                  str = 'wxc0eebdec65b19c45'
                  str1 = 'm.evatmaster.com%2fsystem'
                } else if (
                  isPrdUrl.indexOf('m1.mp.evatmaster.com') != -1 ||
                  isPrdUrl.indexOf('m1.ost.com') != -1
                ) {
                  str = 'wx9c6b7411242fab1a'
                  str1 = 'm1.mp.evatmaster.com%2fsystem'
                } else if (
                  isPrdUrl.indexOf('m.mp.evatmaster.com') != -1 ||
                  isPrdUrl.indexOf('m.ost.com') != -1
                ) {
                  str = 'wxd171949afbc94bbb'
                  str1 = 'm.mp.evatmaster.com%2fsystem'
                } else {
                  str = 'wxf00dd2ff877812bf'
                  str1 = 'wjw.mp.evatmaster.com%2fsystem'
                }
                if (
                  isWeixin &&
                  phone.indexOf('Windows') == -1 &&
                    phone.indexOf('Macintosh') == -1
                ) {
                  let str2 = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${str}&redirect_uri=http%3a%2f%2f${str1}%2f&response_type=code&scope=snsapi_userinfo&state=${str3}#wechat_redirect`
                  window.location.href = str2
                } else if (
                  isWeixin &&
                  (phone.indexOf('Windows') != -1 ||
                    phone.indexOf('Macintosh') != -1)
                ) {
                  window.location.href =
                    'https://user.evatmaster.com/user/login'
                } else {
                  next({ name: 'loginTest', query: { redirect: to.fullPath } })
                }
              } else {
                let isPrdUrl = window.location.href
                let str = ''
                let str1 = ''
                let str3 = ''
                if (to.query.state && to.query.state != 'STATE') {
                  str3 = to.query.state
                } else {
                  str3 = 'STATE'
                }
                if (isPrdUrl.indexOf('m.evatmaster.com') != -1) {
                  str = 'wxc0eebdec65b19c45'
                  str1 = 'm.evatmaster.com%2fsystem'
                } else if (
                  isPrdUrl.indexOf('m1.mp.evatmaster.com') != -1 ||
                  isPrdUrl.indexOf('m1.ost.com') != -1
                ) {
                  str = 'wx9c6b7411242fab1a'
                  str1 = 'm1.mp.evatmaster.com%2fsystem'
                } else if (
                  isPrdUrl.indexOf('m.mp.evatmaster.com') != -1 ||
                  isPrdUrl.indexOf('m.ost.com') != -1
                ) {
                  str = 'wxd171949afbc94bbb'
                  str1 = 'm.mp.evatmaster.com%2fsystem'
                } else {
                  str = 'wxf00dd2ff877812bf'
                  str1 = 'wjw.mp.evatmaster.com%2fsystem'
                }
                if (
                  isWeixin &&
                  phone.indexOf('Windows') == -1 &&
                    phone.indexOf('Macintosh') == -1
                ) {
                  let str2 = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${str}&redirect_uri=http%3a%2f%2f${str1}%2f&response_type=code&scope=snsapi_userinfo&state=${str3}#wechat_redirect`
                  window.location.href = str2
                } else if (
                  isWeixin &&
                  (phone.indexOf('Windows') != -1 ||
                    phone.indexOf('Macintosh') != -1)
                ) {
                  window.location.href =
                    'https://user.evatmaster.com/user/login'
                } else {
                  next({ name: 'loginTest', query: { redirect: to.fullPath } })
                }
              }
            })
          })
      } else {
        next()
      }
    }
  } else {
    if (whiteList.includes(to.name)) {
      next()
    } else {
      if (to.query.code) {
        if (to.name != 'loginBottom') {
          if (
            isWeixin &&
            phone.indexOf('Windows') == -1 && phone.indexOf('Macintosh') == -1
          ) {
            // let pathStr = '/system/user/loginBottom';
            Vue.ls.remove('ACCESS_TOKEN')
            Vue.ls.remove('WX_OPENID')
            store
              .dispatch('loginMp', { code: to.query.code || from.query.code })
              .then(res => {
                if (res.code == 0) {
                  if (res.data && res.data.serialNo) {
                    Vue.ls.set('WX_OPENID', res.data.serialNo)
                  } else {
                    Vue.ls.set('WX_OPENID', res.data)
                  }
                  Vue.ls.set('WX_STATE', to.query.state)
                  Vue.ls.set('ACCESS_TOKEN', res.token)
                  next({ name: 'loginLoading', query: res.data })
                } else if (res.code == 5) {
                  if (res.data && res.data[0].serialNo) {
                    Vue.ls.set('WX_OPENID', res.data[0].serialNo)
                  } else {
                    Vue.ls.set('WX_OPENID', res.data)
                  }
                  Vue.ls.set('WX_STATE', to.query.state)
                  next({
                    name: 'loginList',
                    query: { list: res.data, type: 2 }
                  })
                } else if (res.code == 2) {
                  if (res.data && res.data.serialNo) {
                    Vue.ls.set('WX_OPENID', res.data.serialNo)
                  } else {
                    Vue.ls.set('WX_OPENID', res.data)
                  }
                  Vue.ls.set('WX_STATE', to.query.state)
                  next({ name: 'login' })
                } else {
                  Vue.ls.remove('ACCESS_TOKEN')
                  Vue.ls.remove('WX_OPENID')
                  let isPrdUrl = window.location.href
                  let str = ''
                  let str1 = ''
                  let str3 = ''
                  if (to.query.state && to.query.state != 'STATE') {
                    str3 = to.query.state
                  } else {
                    str3 = 'STATE'
                  }
                  if (isPrdUrl.indexOf('m.evatmaster.com') != -1) {
                    str = 'wxc0eebdec65b19c45'
                    str1 = 'm.evatmaster.com%2fsystem'
                  } else if (
                    isPrdUrl.indexOf('m1.mp.evatmaster.com') != -1 ||
                    isPrdUrl.indexOf('m1.ost.com') != -1
                  ) {
                    str = 'wx9c6b7411242fab1a'
                    str1 = 'm1.mp.evatmaster.com%2fsystem'
                  } else if (
                    isPrdUrl.indexOf('m.mp.evatmaster.com') != -1 ||
                    isPrdUrl.indexOf('m.ost.com') != -1
                  ) {
                    str = 'wxd171949afbc94bbb'
                    str1 = 'm.mp.evatmaster.com%2fsystem'
                  } else {
                    str = 'wxf00dd2ff877812bf'
                    str1 = 'wjw.mp.evatmaster.com%2fsystem'
                  }
                  if (
                    isWeixin &&
                    phone.indexOf('Windows') == -1 &&
                      phone.indexOf('Macintosh') == -1
                  ) {
                    let str2 = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${str}&redirect_uri=http%3a%2f%2f${str1}%2f&response_type=code&scope=snsapi_userinfo&state=${str3}#wechat_redirect`
                    window.location.href = str2
                  } else if (
                    isWeixin &&
                    (phone.indexOf('Windows') != -1 ||
                      phone.indexOf('Macintosh') != -1)
                  ) {
                    window.location.href =
                      'https://user.evatmaster.com/user/login'
                  } else {
                    next({
                      name: 'loginTest',
                      query: { redirect: to.fullPath }
                    })
                  }
                }
              })
            // next({ path:pathStr ,query:to.query})
          } else if (
            isWeixin &&
            (phone.indexOf('Windows') != -1 || phone.indexOf('Macintosh') != -1)
          ) {
            window.location.href = 'https://user.evatmaster.com/user/login'
          } else {
            Vue.ls.remove('ACCESS_TOKEN')
            Vue.ls.remove('WX_OPENID')
            next({ name: 'loginTest', query: { redirect: to.fullPath } })
          }
        }
      } else {
        // Toast({
        //     message: '重新获取授权信息',
        //     duration: 3000
        // })
        let isPrdUrl = window.location.href
        let str = ''
        let str1 = ''
        let str3 = ''
        if (to.query.state && to.query.state != 'STATE') {
          str3 = to.query.state
        } else {
          str3 = 'STATE'
        }
        if (isPrdUrl.indexOf('m.evatmaster.com') != -1) {
          str = 'wxc0eebdec65b19c45'
          str1 = 'm.evatmaster.com%2fsystem'
        } else if (
          isPrdUrl.indexOf('m1.mp.evatmaster.com') != -1 ||
          isPrdUrl.indexOf('m1.ost.com') != -1
        ) {
          str = 'wx9c6b7411242fab1a'
          str1 = 'm1.mp.evatmaster.com%2fsystem'
        } else if (
          isPrdUrl.indexOf('m.mp.evatmaster.com') != -1 ||
          isPrdUrl.indexOf('m.ost.com') != -1
        ) {
          str = 'wxd171949afbc94bbb'
          str1 = 'm.mp.evatmaster.com%2fsystem'
        } else {
          str = 'wxf00dd2ff877812bf'
          str1 = 'wjw.mp.evatmaster.com%2fsystem'
        }
        // 判断是手机端并且在 微信浏览器打开
        if (
          isWeixin &&
          phone.indexOf('Windows') == -1 && phone.indexOf('Macintosh') == -1
        ) {
          let str2 = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${str}&redirect_uri=http%3a%2f%2f${str1}%2f&response_type=code&scope=snsapi_userinfo&state=${str3}#wechat_redirect`
          window.location.href = str2
        } else if (
          isWeixin &&
          (phone.indexOf('Windows') != -1 || phone.indexOf('Macintosh') != -1)
        ) {
          window.location.href = 'https://user.evatmaster.com/user/login'
        } else {
          next({ name: 'loginTest', query: { redirect: to.fullPath } })
        }
      }

      // window.location.href='https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf00dd2ff877812bf&redirect_uri=http%3a%2f%2fwjw.mp.evatmaster.com%2f&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
      // next({name:"mine"})
    }
  }
})

// router.afterEach(() => {
// })

router.onError(error => {
  const pattern = /Loading chunk (\d)+ failed/g
  const isChunkLoadFailed = error.message.match(pattern)
  if (isChunkLoadFailed) {
    location.reload()
  } else {
    location.reload()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js